import { QueryEntity } from '@datorama/akita';
import { MaintenanceTicketState, maintenanceTicketStore } from './maintenance-ticket.store';
import { switchMap } from 'rxjs/operators';
import { dateRangeFilter, MaintenanceCategory } from './maintenance-ticket.model';
export class MaintenanceTicketQuery extends QueryEntity<MaintenanceTicketState> {
  filters = this.select(({ ui }) => ui);

  categories = this.select(({ ui }) => ui.categories ?? Array<MaintenanceCategory>());

  maintenanceTickets = this.filters.pipe(
    switchMap(ui =>
      this.selectAll({
        filterBy: [
          x => x.propertyId === ui.propertyId,
          x => dateRangeFilter(x, ui.startDate, ui.endDate),
          x => ui.status == null || x.status === ui.status,
          x => ui.assignedTo == null || x.assignedTo?.id === ui.assignedTo,
          x => x.deletedOn === null,
          x => ui.priority == null || x.priority === ui.priority,
          x => ui.active == null || ui.active === false || x.isActive === ui.active,
          x => !ui.location || x.roomNumber === ui.location || x.area === ui.location,
          x => {
            const text = ui.textFilter?.toLowerCase();
            if (!text) return true;
            return (
              x.ticketNumber.toString().toLowerCase().includes(text) ||
              (!!x.roomNumber && x.roomNumber.toLowerCase().includes(text)) ||
              (x.description?.some(y => y.toLowerCase().includes(text)) ?? false)
            );
          },
          x => !ui.creationSource || x.creationSource === ui.creationSource,
        ],
        sortBy: (a, b) => b.ticketNumber - a.ticketNumber,
      })
    )
  );

  possibleDuplicates = this.select(({ ui }) => ui.duplicateTickets);

  duplicateTicketPaginationState = this.select(({ ui }) => ui.duplicateTicketPaginationState);

  isLoading = this.selectLoading();

  selectedTicket = this.selectActive();

  pagination = this.select(x => x.pagination);

  photos = this.select(ui => ui.photos);

  entryCode = this.select(ui => ui.entryCode);
}

export const maintenanceTicketQuery = new MaintenanceTicketQuery(maintenanceTicketStore);
